/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysquePropertiesListModule } from '../../../../../../../shared/ui/src/lib/components/sysque-properties-list';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueToggleButtonModule } from '../../../../../../../shared/ui/src/lib/components/sysque-switch-button';
import { SysqueTextBoxDescriptionModule } from '../../../../../../../shared/ui/src/lib/components/sysque-text-area-description';
import { DxButtonModule, DxTabPanelModule } from 'devextreme-angular';
import { RouterModule, Routes } from '@angular/router';
import { SysqueContextMenuModule } from '../../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { HangerSpecificationFamilyInformation } from './hanger-specification-family-information.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/field-fab-family-information-dialog', component: HangerSpecificationFamilyInformation }];

@NgModule({
  declarations: [HangerSpecificationFamilyInformation],
  imports: [
    CommonModule, 
    SysquePropertiesListModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueToggleButtonModule,
    SysqueTextBoxDescriptionModule,
    DxButtonModule, 
    DxTabPanelModule,
    AlertModule,
    SysqueContextMenuModule,
    ColorPickerModule,
    RouterModule.forChild(routes)
  ],
  exports: [HangerSpecificationFamilyInformation],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HangerSpecificationFamilyInformationModule {}